module.exports = __webpack_public_path__ + "img/IMG_1645_Black.e85ff587.jpg";